var render, staticRenderFns
import script from "./CorrectMixin.vue?vue&type=script&lang=js&"
export * from "./CorrectMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319eeca8",
  null
  
)

export default component.exports